<app-breadcrumb></app-breadcrumb>
<mat-card class="cardWithShadow">
    <!-- <mat-progress-bar mode="indeterminate"></mat-progress-bar> -->
        <mat-tab-group mat-stretch-tabs="false" animationDuration="0ms">
            <form>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="d-flex align-items-center">
                            <mat-icon>
                                <i-tabler name="list-details" class="icon-20 m-r-8"></i-tabler>
                            </mat-icon>
                        </div>
                        {{ 'ENTITY.APPOINTMENT_TYPE' | translate }}

                    </ng-template>
                    <mat-card-content class="p-y-10">

                        <div class="row">
                            <div class="col-sm-12">
                                <div class="m-t-20">
                                    <app-appointment-type></app-appointment-type>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-tab>
            </form>

            <!-- <mat-tab>
                <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                        <mat-icon>
                            <i-tabler name="file-description" class="icon-20 m-r-8"></i-tabler>
                        </mat-icon>
                    </div>
                    Details
                </ng-template>
                <mat-card-content class="p-y-24 b-t-1">
                    
                </mat-card-content>
            </mat-tab> -->

            <!-- <mat-tab>
                <ng-template mat-tab-label>
                    <div class="d-flex align-items-center">
                        <mat-icon>
                            <i-tabler name="shield-lock" class="icon-20 m-r-8"></i-tabler>
                        </mat-icon>
                    </div>
                    Security
                </ng-template>
                <mat-card-content class="p-y-24 b-t-1">

                </mat-card-content>
            </mat-tab> -->

        </mat-tab-group>
</mat-card>